"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityFinalNegotiationServiceLevelAgreement = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_final_negotiation_entity_1 = require("./opportunity-final-negotiation.entity");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityFinalNegotiationServiceLevelAgreement = class OpportunityFinalNegotiationServiceLevelAgreement {
};
exports.OpportunityFinalNegotiationServiceLevelAgreement = OpportunityFinalNegotiationServiceLevelAgreement;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationServiceLevelAgreement.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'opportunity_final_negotiation_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationServiceLevelAgreement.prototype, "opportunityFinalNegotiationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'service_type_id', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationServiceLevelAgreement.prototype, "serviceTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'number_of_days', type: 'int' }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationServiceLevelAgreement.prototype, "numberOfDays", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_final_negotiation_entity_1.OpportunityFinalNegotiation, (neg) => neg.slaDetails, { onDelete: 'CASCADE' }),
    (0, typeorm_1.JoinColumn)({ name: 'opportunity_final_negotiation_id' }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationServiceLevelAgreement.prototype, "finalNegotiation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: 'service_type_id' }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiationServiceLevelAgreement.prototype, "serviceType", void 0);
exports.OpportunityFinalNegotiationServiceLevelAgreement = OpportunityFinalNegotiationServiceLevelAgreement = tslib_1.__decorate([
    (0, typeorm_1.Entity)('opportunity_final_negotiation_service_level_agreement')
], OpportunityFinalNegotiationServiceLevelAgreement);
